import * as React from 'react'
import type { Color } from '../../../theme/colors'
import colors from '../../../theme/colors'

type Props = React.SVGProps<SVGSVGElement> & {
  width?: number,
  height?: number,
  color?: Color,
}

const CancelSvg = ({ width, height, color, ...rest }: Props) => {
  const viewBox = `0 0 ${width || 0} ${height || 0}`

  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M8.40284 6.99506L12.6987 2.70859C12.8868 2.52044 12.9925 2.26526 12.9925 1.99918C12.9925 1.73309 12.8868 1.47791 12.6987 1.28976C12.5106 1.10161 12.2554 0.995911 11.9894 0.995911C11.7233 0.995911 11.4682 1.10161 11.2801 1.28976L6.9942 5.58622L2.70834 1.28976C2.52022 1.10161 2.26507 0.995911 1.99903 0.995911C1.73298 0.995911 1.47784 1.10161 1.28971 1.28976C1.10159 1.47791 0.995907 1.73309 0.995907 1.99918C0.995907 2.26526 1.10159 2.52044 1.28971 2.70859L5.58556 6.99506L1.28971 11.2815C1.19608 11.3744 1.12175 11.4849 1.07103 11.6067C1.02031 11.7284 0.994202 11.859 0.994202 11.9909C0.994202 12.1228 1.02031 12.2534 1.07103 12.3752C1.12175 12.497 1.19608 12.6075 1.28971 12.7004C1.38259 12.794 1.49308 12.8683 1.61482 12.9191C1.73657 12.9698 1.86714 12.9959 1.99903 12.9959C2.13091 12.9959 2.26149 12.9698 2.38323 12.9191C2.50498 12.8683 2.61547 12.794 2.70834 12.7004L6.9942 8.4039L11.2801 12.7004C11.3729 12.794 11.4834 12.8683 11.6052 12.9191C11.7269 12.9698 11.8575 12.9959 11.9894 12.9959C12.1213 12.9959 12.2518 12.9698 12.3736 12.9191C12.4953 12.8683 12.6058 12.794 12.6987 12.7004C12.7923 12.6075 12.8666 12.497 12.9174 12.3752C12.9681 12.2534 12.9942 12.1228 12.9942 11.9909C12.9942 11.859 12.9681 11.7284 12.9174 11.6067C12.8666 11.4849 12.7923 11.3744 12.6987 11.2815L8.40284 6.99506Z"
        fill={color}
      />
    </svg>
  )
}

CancelSvg.defaultProps = {
  width: 13,
  height: 13,
  color: colors.Primary.GreyText
}

export default CancelSvg
